import { PaginationComponent } from './pagination/pagination.component';

export const Components = [
	PaginationComponent,
];
